/**
 * Custom element that keeps the global `--announcement-bar-height` custom property up to date.
 *
 * The announcement bar section sticks to the top of the viewport on its own, but a sticky header
 * needs to know how tall the bar is so it can stick right below it instead of underneath it.
 */
class AnnouncementBarSticky extends HTMLElement {
  #resizeObserver = new ResizeObserver(([entry]) => {
    if (!entry) return;

    const { height } = entry.target.getBoundingClientRect();
    document.body.style.setProperty('--announcement-bar-height', `${height}px`);
  });

  connectedCallback() {
    this.#resizeObserver.observe(this);
  }

  disconnectedCallback() {
    this.#resizeObserver.disconnect();
    document.body.style.removeProperty('--announcement-bar-height');
  }
}

if (!customElements.get('announcement-bar-sticky')) {
  customElements.define('announcement-bar-sticky', AnnouncementBarSticky);
}
